import { useTranslation } from 'react-i18next';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (n: number) => void;
}

export function Pagination({ page, totalPages, onPageChange }: PaginationProps) {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;

  const prev = () => onPageChange(Math.max(1, page - 1));
  const next = () => onPageChange(Math.min(totalPages, page + 1));

  return (
    <nav aria-label={t('home.pagination.label')} className="flex items-center justify-center gap-2 pt-2">
      <button
        type="button"
        onClick={prev}
        disabled={page === 1}
        className="rounded-md border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {t('home.pagination.prev')}
      </button>
      <p className="text-xs text-slate-600">
        {t('home.pagination.position', { page, total: totalPages })}
      </p>
      <button
        type="button"
        onClick={next}
        disabled={page === totalPages}
        className="rounded-md border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {t('home.pagination.next')}
      </button>
    </nav>
  );
}
